import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import classnames from 'classnames'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useTranslation, Trans } from 'react-i18next'

import { selectSelectedStudents } from '../../../../reducers/programDashboardReducer'
import { forceSeriesRefresh } from '../../../../reducers/seriesReducer'
import Modal from '../../../common/Modal'
import SubmitButton from '../../../common/buttons/SubmitButton'
import Input from '../../../common/form/Input'

import { ReactComponent as CompletedIcon } from '../../../../assets/images/common/icons/check-circle-white.svg'
import classes from './WaitlistStudentsConfirmationModal.module.scss'
import { addStudentsToWaitlistManually } from '../../../../actions/waitlistActions'

const WaitlistStudentsConfirmationModal = props => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const course = useSelector(state => state.programDashboard.program)
  const selectedStudents = useSelector(selectSelectedStudents)

  const [message, setMessage] = useState('')

  const handleConfirmButtonClick = () => {
    const students = selectedStudents.map(s => s.id)

    dispatch(addStudentsToWaitlistManually({ course, students, coachMessage: message })).unwrap()
      .then(() => {
        toast.success(t('programs.manage.waitlistConfirmation.successToast'), { position: toast.POSITION.TOP_RIGHT })
      })
      .catch(() => toast.error(t('common.somethingWentWrong'), { position: toast.POSITION.TOP_RIGHT }))
      .finally(() => { props.onClose(); dispatch(forceSeriesRefresh()) })
  }

  return (
    <Modal className={classnames('px-5', classes.modal)} {...props}>
      <div className='d-flex flex-column justify-content-center align-items-center'>
        <CompletedIcon className={classnames('mb-4', classes.completedIcon)} />
        <h1 className={classes.title}>
          <Trans i18nKey='programs.manage.waitlistConfirmation.title' components={{ br: <br /> }} />
        </h1>
        <p className={classnames('my-3', classes.subTitle)}>
          {t('programs.manage.waitlistConfirmation.subTitle', {
            count: selectedStudents.length,
            addStudents: t('programs.common.addStudents'),
          })}
        </p>
        <Input
          name='description'
          type='textarea'
          onChange={e => setMessage(e.target.value)}
          placeholder={t('programs.common.messageToGolfers')}
          value={message}
          classNames={{ inputContainer: classes.coachMessageInputContainer }}
        />
      </div>
      <div>
        <div className='row py-3'>
          <div className='col-12'>
            <SubmitButton
              onClick={() => handleConfirmButtonClick()}
              buttonMessage={t('programs.common.addStudents')}
              buttonColor='orange-button'
            />
          </div>
          <div className='col-12'>
            <SubmitButton
              onClick={() => props.onClose()}
              buttonMessage={t('common.cancel')}
              buttonColor='navy-button'
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

WaitlistStudentsConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default WaitlistStudentsConfirmationModal
